<mat-toolbar class="custom-header-toolbar h-100">

    <!-- Menu -->
    <mat-toolbar-row class="h-100">
        <app-header-menu class="w-100"></app-header-menu>
	</mat-toolbar-row>
	
</mat-toolbar>
